module.exports = __webpack_public_path__ + "img/charles yates, 1958.7ee47dd7.jpg";